<ion-card *ngIf="data"
  class="notification-2 alert-margin"
  [ngClass]="{
    'notification-2--success': type === 'SUCCESS',
    'notification-2--warning': type === 'WARNING'
  }"
>
  <div class="notification-2__header">
    <ng-container [ngSwitch]="type">
      <ion-icon
        *ngSwitchCase="'WARNING'"
        class="white icon-header"
        name="warning"
      ></ion-icon>
      <ion-icon
        *ngSwitchCase="'SUCCESS'"
        name="checkmark"
        class="white icon-header"
      ></ion-icon>
    </ng-container>
  </div>
  <ion-card-content class="notification-2__content">
    <div class="notification-2__row">
      <span class="notification-2__text white mapfre-fs-xs df ai-c">
        {{ data.text }}
      </span>
      <ion-button
        *ngIf="data.buttonText"
        fill="clear"
        color="white"
        class="notification-2__action-button mapfre-fw-500"
        (click)="onAction()"
      >
        {{ data.buttonText }}
      </ion-button>
    </div>
    <ion-button
      *ngIf="showCloseBtn"
      fill="clear"
      color="white"
      class="notification-2__close"
      (click)="onClose()"
    >
      <ion-icon name="close"></ion-icon>
    </ion-button>
  </ion-card-content>
</ion-card>
